import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useSidebar } from '../../contexts/SidebarContext';

export const ThemeToggle: React.FC = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();
  const { isCollapsed } = useSidebar();

  return (
    <button
      onClick={toggleDarkMode}
      className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors duration-200 text-white/80 hover:bg-white/5"
    >
      {isDarkMode ? (
        <Sun className="w-5 h-5 flex-shrink-0" />
      ) : (
        <Moon className="w-5 h-5 flex-shrink-0" />
      )}
      <span 
        className={`whitespace-nowrap transition-opacity duration-300 ${
          isCollapsed ? 'opacity-0' : 'opacity-100'
        }`}
      >
        {isDarkMode ? 'Mode clair' : 'Mode sombre'}
      </span>
    </button>
  );
};